// Get the modal
var modal = document.getElementById("size-modal");

var modal1 = document.getElementById("news-modal");

var modal2 = document.getElementById("ship-modal");

// Get the button that opens the modal
var btn = document.getElementById("size-guide");

var btn1 = document.getElementById("news-pop");

var btn2 = document.getElementById("ship-popup");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

var span1 = document.getElementsByClassName("close1")[0];

var span2 = document.getElementsByClassName("close2")[0];

// When the user clicks on the button, open the modal
if(btn != null)
{
btn.onclick = function() {
  var data = btn.getAttribute("data-chart");
  document.getElementById("modal-data").innerHTML = data;
  modal.style.display = "block";
}
}
if(btn1 != null)
{
btn1.onclick = function() {
  modal1.style.display = "block";
}
}
if(btn2 != null)
{
btn2.onclick = function() {
  modal2.style.display = "block";
}
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

span1.onclick = function() {
  modal1.style.display = "none";
}


span2.onclick = function() {
  modal2.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
  if (event.target == modal1) {
    modal1.style.display = "none";
  }
  if (event.target == modal2) {
    modal2.style.display = "none";
  }
}


// $(".img-gallery .img-zoom").on("click",function(){
// 	$(this).toggleClass("active");
//     var left = $(".orignal-img").width();
//     var top = $(".orignal-img").height();
// 	 var relX = event.pageX - $(this).offset().left + left / 12 - 40;
//      var relY = event.pageY - $(this).offset().top + top / 12 - 55 ;
//     $(this).find(".zoom-imag").css({"left":-relX,"top":-relY});
//   $(".active").mousemove(function(event){
//     var left = $(".orignal-img").width();
//     var top = $(".orignal-img").height();
// 	 var relX = event.pageX - $(this).offset().left + left / 12 - 40 ;
//      var relY = event.pageY - $(this).offset().top + top / 12 - 55;
//     $(this).find(".zoom-imag").css({"left":-relX,"top":-relY});
// });
// });

  $(".mob").slick({

  // normal options...
  infinite: false,

  // the magic
  responsive: [{

      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        infinite: true,
        dots:true,
        arrows:false
      }

    }, {

      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows:false
      }

    }, {

      breakpoint: 300,
      settings: "unslick" // destroys slick

    }]
});

$(".back-top").on("click",function(){
	$('html, body').animate({scrollTop : 0},800);
        return false;
});

// jQuery('#notify-me').click(function() {

// jQuery('#notify-me-wrapper').toggle();

// return false;
// } );

// $(".single-option-selector").on("change",function(){
//   setTimeout(function(){
// 	notify();
//   }, 100);
// });

// notify();

function notify(){
  var check = $(".product-form__cart-submit").attr("aria-label");
  if(check == "Sold out")
  {
    $(".product-form__cart-submit").hide();
    $("#sold-out").show();
    var vrint = $("#ProductSelect-product-template").val();
    var title = $("#ProductSelect-product-template option[value='"+vrint+"']").text();
    title = title.trim();
    title = title.replace(" - Sold out","");
    var product_title = $(".product-single__title").text();
    $("#msg-content").val("Please notify me when "+product_title+" - "+title+" becomes available.")
  }
  else
  {
    $(".product-form__cart-submit").show();
    $("#sold-out").hide();
  }
}

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
  	var h1 = $(".prod-right").height();
    var h2 = $(".top-images").height();
  	var fh = h1 / 2 + h2;
  	var fh1 = h1 - h2;
    var h = h1 + h2;
    if (scroll > h1) {
      $(".prod-right").css({"top":-fh1});
      $(".prod-right").addClass("stick");
    }
    else if(scroll < h2) {
      $(".prod-right").removeClass("stick");
      $(".prod-right").removeClass("top");
    }
    var v1 = $(".prod_img").height();
    var v1 = v1 + h2 - 400;
    if(scroll > v1)
    {
      $(".prod-right").addClass("top");
    }
});

$("#SiteNav li.site-nav--has-dropdown").on("click",function(e){
  e.preventDefault();
  e.stopPropagation();
  if($(this).hasClass("site-nav--has-dropdown"))
  {
    $(this).toggleClass("nav-active");
  }
  $(this).siblings().removeClass("nav-active");
});

// Location Switcher (Header)
$( '.site-header--location button' ).on( "click", function(e) {
  e.preventDefault();
  e.stopPropagation();

  $( this ).next().toggleClass( 'location-list-active' );

});

$( '[data-value="London"]' ).on( "click", function(e) {
  e.preventDefault();
  $( '.location-list-active' ).removeClass( 'location-list-active' );
});

// Close Location Checker (Via Button)
$( '.close-location-splash-button, .close-location-splash.close' ).on( 'click', function(e) {
  e.preventDefault();

  $( 'body' ).removeClass( 'show-location-prompt' );
  document.cookie = "clear-location-prompt-for-visit=Yes";

  if( $('.location-checkbox').is(":checked") ) {
      var CookieDate = new Date;
      CookieDate.setFullYear(CookieDate.getFullYear() +10);
      document.cookie = 'clear-location-prompt-permanently=yes; expires=' + CookieDate.toUTCString() + ';';
  }

});

// Check If Location Check Cookie Exists
(function() {
  
  if( ( !document.cookie.match(/^(.*;)?\s*clear-location-prompt-for-visit\s*=\s*[^;]+(.*)?$/ ) ) || ( !document.cookie.match(/^(.*;)?\s*clear-location-prompt-permanently\s*=\s*[^;]+(.*)?$/ ) ) ) {

    setTimeout(() => {
      $( 'body' ).addClass( 'show-location-prompt' );    
    }, 1500);
  }

  
})();

(() => {

  if( !document.querySelector( '.product-overlay' ) ) return;

  $( '[data-nav-item]' ).each(function() {
    $( this ).on( 'click', function(e) {
      e.preventDefault();
      let $index = $( this ).attr( 'data-nav-item' );
      let $target = $( '[data-gallery-item="'+$index+'"]' );
      // $('.product-overlay').scrollTop(0);
      var $currScrollTop = $(".product-overlay").scrollTop();

      $( '.product-overlay' ).animate({
        // scrollTop: $target.offset().top
        scrollTop: ( $currScrollTop + $target.position().top - $('.product-overlay').position().top ) - 7
      });
    });
  });

  $( '.img-zoom' ).each(function() {
    $( this ).on( 'click', (e) => {
      e.preventDefault();
      if( $( window ).width() < 1000 ) return;
      $( '.product-overlay' ).addClass( 'product-overlay__visible' );
    });
  });

  $( '.product-overlay__close' ).on( 'click', (e) => {
    e.preventDefault();

    $( '.product-overlay' ).removeClass( 'product-overlay__visible' );
    let activeZoom = document.querySelector( '.zoom-feature-active' );
    if( activeZoom ) {
      activeZoom.classList.remove( 'zoom-feature-active' );
    }
  });

  let productImages = document.querySelectorAll( '.product-overlay__zoom-image' );

  function zoom(e){
    var zoomer = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
    x = offsetX/zoomer.offsetWidth*100
    y = offsetY/zoomer.offsetHeight*100
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

  if( productImages.length ) {
    productImages.forEach((image) => {
      image.addEventListener( 'click', (e) => {
        let activeZoom = document.querySelector( '.zoom-feature-active' );
    
        if( e.currentTarget.classList.contains( 'zoom-feature-active' ) ) {
          e.currentTarget.classList.remove( 'zoom-feature-active' );
        } else {
          if( activeZoom ) {
            activeZoom.classList.remove( 'zoom-feature-active' );
          }
          e.currentTarget.classList.add( 'zoom-feature-active' );
        }
        
        // if( activeZoom ) {
        //   if( activeZoom.classList.contains( 'zoom-feature-active' ) ) {
        //     activeZoom.classList.remove( 'zoom-feature-active' );
        //   } 
        // }
        
        // image.classList.toggle( 'zoom-feature-active' );
      });
      
      image.addEventListener( 'mousemove', (e) => {
        zoom(e);
      });
    });
  }
  
  
})();

// Cart Duties Checkbox Check
(() => {

  const duties = document.querySelector('.cart__duties-checkbox');
  let checkoutButtons = document.querySelectorAll( '.cart__submit' );
  if( !duties ) return;
  duties.addEventListener('change', e => {
    if(e.target.checked === true) {
      checkoutButtons.forEach((button) => {
        button.removeAttribute( 'disabled' );
      });
      // console.log("Checkbox is checked - boolean value: ", e.target.checked)
    }
  if(e.target.checked === false) {
      checkoutButtons.forEach((button) => {
        button.setAttribute( 'disabled', '' );
      });
    }
  });

})();


  // $("document").ready(function() {
  // $(".email-to-enquire-btn").on("click", function() {
  //    $(".contact-form-popup__body").addClass("show_popup");
  //     $(".contact-form-popup__body").show();
  //   $(".contact-form-popup__bg").show();
  //   $("body").addClass("flow-hidden");
      
  //   console.log("found");
  // });
  //   $(".contact-form_popup_close").on("click", function() {
  //      $(".contact-form-popup__body").removeClass("show_popup");
  //    $(this).parents(".contact-form-popup__body").hide();
  //     $("body").removeClass("flow-hidden");
  //     console.log("not found");
  // });
  //   $(".contact-form-popup__bg").on("click", function() {
  //      $(".contact-form-popup__body").removeClass("show_popup");
  //    $(this).parents(".contact-form-popup__body").hide();
  //    $("body").removeClass("flow-hidden");
  //     console.log("not found");
  // });

  // });